<app-resource-subtitle></app-resource-subtitle>
<div class="row interactive-layout">
    <div class="col-lg-8">
        <app-generic-interactive-preview
            *ngIf="resource"
            [interactiveAsset]="resource.selectedAsset"
        >
        </app-generic-interactive-preview>
        <app-resource-details></app-resource-details>
    </div>
    <div class="col-lg-4 recommended selenium-related-resources">
        <app-support-material-panel
            [resource]="resource"
            *ngIf="!windowSize.isTablet"
            style="margin-bottom: 30px"
        ></app-support-material-panel>
        <ng-container *ngIf="!isAddonView">
            <app-related-resources
                *ngIf="resource"
                [resource]="resource"
                class="selenium-you-may-also-like"
            ></app-related-resources>
            <app-curriculum-tags></app-curriculum-tags>
        </ng-container>
    </div>
</div>
<div class="row-auto">
    <app-more-from-collection></app-more-from-collection>
</div>
